"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TreeNode = /** @class */ (function () {
    function TreeNode(location) {
        this.location = location;
    }
    return TreeNode;
}());
exports.default = TreeNode;
//# sourceMappingURL=TreeNode.js.map